import { useState } from "react";
import EditDataApiPermissionForm from "./EditDataApiPermissionForm";
import DialogFormPanel from "../../../../../../../../shared/components/panel/DialogFormPanel";
import UpdateButtonTrigger from "../../../../../../../../shared/components/button/UpdateButtonTrigger";

const EditDataApiPermissionDialog = ({
  onSubmitHandler,
  permission,
  roles,
  datasets,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = (formValues) => {
    onSubmitHandler(permission.id, formValues);
    setIsOpen(false);
  };

  return (
    <DialogFormPanel
      trigger={<UpdateButtonTrigger />}
      title="Editar permiso"
      description="Editar permiso en Data API"
      content={
        <EditDataApiPermissionForm
          onSubmitHandler={onSubmit}
          permission={permission}
          roles={roles}
          datasets={datasets}
        />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default EditDataApiPermissionDialog;
